<template>
  <v-dialog v-model="dialog" light persistent class="elevation-5">
    <s-toolbar label="Documentación Sun Expert">
      <v-btn text @click="cancel()" class="btn-back">
        Atras
      </v-btn>
    </s-toolbar>
    <div class="doc-container">
      <!-- Sidebar -->
      <aside class="sidebar">
        <div v-for="cat in categorias" :key="cat.nombre">
          <h2>{{ cat.nombre }}</h2>
          <ul>
            <li v-for="doc in cat.docs" :key="doc.title">
              <button @click="loadDoc(doc.url)">
                {{ doc.title }}
              </button>
            </li>
          </ul>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="content-container">
        <v-md-preview :text="markdownContent" />
      </main>
    </div>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/style/preview.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';

import 'prismjs/components/prism-json';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-sql';

VMdPreview.use(vuepressTheme, { Prism });
Vue.use(VMdPreview);
export default {
  data() {
    return {
      dialog: true,
      categorias: [],
      markdownContent: "",
    };
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$router.go(-1);
    },
    async fetchDocs() {
      try {
        const response = await fetch("/docs/SunExpert/docs.json");
        if (!response.ok) {
          throw new Error(
            `Error al cargar la lista de documentos: ${response.statusText}`
          );
        }
        const data = await response.json();
        // El JSON es un array de objetos, cada uno con una categoría
        this.categorias = data.map((catObj) => {
          const categoria = Object.keys(catObj)[0];
          return {
            nombre: categoria,
            docs: catObj[categoria],
          };
        });
      } catch (error) {
        console.error(error);
      }
    },
    async loadDoc(url) {
      let docPath = "/docs/" + url;
      try {
        const response = await fetch(docPath);
        if (!response.ok) {
          throw new Error(`Error al cargar el archivo: ${response.statusText}`);
        }
        const text = await response.text();
        this.markdownContent = text;
      } catch (error) {
        console.error(error);
        this.markdownContent = `<p>Error al cargar el archivo: ${error.message}</p>`;
      }
    },
  },
  async created() {
    await this.fetchDocs();
    if (this.categorias.length > 0 && this.categorias[0].docs.length > 0) {
      this.loadDoc(this.categorias[0].docs[0].url);
    }
  },
};
</script>
<style>
.btn-back {
  margin-left: 5px;
  background-color: #b0e719;
  font-size: 16px;
  font-weight: bold;
}

.doc-container {
  display: flex;
  flex-direction: row;
  height: 100vh;
}

/* Sidebar */
.sidebar {
  width: 250px;
  background-color: #f4f4f4;
  padding: 20px;
  border-right: 1px solid #ddd;
  overflow-y: auto;
}

.sidebar h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  margin-bottom: 10px;
}

.sidebar button {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 10px;
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.sidebar button:hover {
  background-color: #e9ecef;
}

/* Contenedor de contenido */
.content-container {
  flex: 1;
  padding: 20px;
  background-color: #fff;
  overflow-y: auto;
}

.content-container h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.content {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}
</style>
